import { useEffect, useState } from 'react'
import type { Bet } from 'src/types/domain/Bet'
import { isMarbleGame } from 'src/types/domain/Game'
import { useGetCurrentGame } from 'src/store/game'
import { useBetActions, useBetStore } from 'src/store/bet'

export const useGetCurrentBet = () => {
  const game = useGetCurrentGame()
  const [currentBet, setCurrentBet] = useState<Bet | undefined>(undefined)
  const betActions = useBetActions()

  const currentRace = isMarbleGame(game) ? game.races[0] : undefined
  const currentRaceId = currentRace?.uuid

  // Update current bet when bets change
  useEffect(() => {
    useBetStore.subscribe(
      (state) => state.bets,
      (bets) => {
        const betId = bets.allIds.find((id) => bets.byId[id]?.raceId === currentRaceId)
        const bet = betId ? bets.byId[betId] : undefined

        if (currentBet?.id !== bet?.id) {
          setCurrentBet(bet)
        }
      },
      { fireImmediately: true }
    )
  }, [betActions, currentRaceId, currentBet])

  // Update current bet when race changes
  useEffect(() => {
    if (currentRaceId) {
      const bet = betActions.getBetByRaceId(currentRaceId)
      if (bet?.id !== currentBet?.id) {
        setCurrentBet(bet)
      }
    }
  }, [currentRaceId, betActions, currentBet?.id])

  return {
    currentBet
  }
}
